/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: P0bQ5GYC74Ng

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import RoundButton from "../../RoundButton"; // plasmic-import: G_YIM-U5ADf4/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFeaturesNavigationMenu.module.css"; // plasmic-import: P0bQ5GYC74Ng/css

import Icon64Icon from "./icons/PlasmicIcon__Icon64"; // plasmic-import: WzuZ8AOmVWTQ/icon

createPlasmicElementProxy;

export type PlasmicFeaturesNavigationMenu__VariantMembers = {
  expanded: "expanded";
  currentSection2: "myEvaluations" | "myCme" | "myGme";
};
export type PlasmicFeaturesNavigationMenu__VariantsArgs = {
  expanded?: SingleBooleanChoiceArg<"expanded">;
  currentSection2?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
};
type VariantPropType = keyof PlasmicFeaturesNavigationMenu__VariantsArgs;
export const PlasmicFeaturesNavigationMenu__VariantProps =
  new Array<VariantPropType>("expanded", "currentSection2");

export type PlasmicFeaturesNavigationMenu__ArgsType = {
  onProductClick?: (id: string) => void;
  currentSection?: string;
};
type ArgPropType = keyof PlasmicFeaturesNavigationMenu__ArgsType;
export const PlasmicFeaturesNavigationMenu__ArgProps = new Array<ArgPropType>(
  "onProductClick",
  "currentSection"
);

export type PlasmicFeaturesNavigationMenu__OverridesType = {
  root?: Flex__<"div">;
  menu?: Flex__<"div">;
  logo?: Flex__<"div">;
  icon?: Flex__<"div">;
  roundButton?: Flex__<typeof RoundButton>;
  arrowIcon?: Flex__<"svg">;
  options?: Flex__<"div">;
  option?: Flex__<"div">;
  option2?: Flex__<"div">;
  option3?: Flex__<"div">;
};

export interface DefaultFeaturesNavigationMenuProps {
  onProductClick?: (id: string) => void;
  currentSection?: string;
  expanded?: SingleBooleanChoiceArg<"expanded">;
  currentSection2?: SingleChoiceArg<"myEvaluations" | "myCme" | "myGme">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFeaturesNavigationMenu__RenderFunc(props: {
  variants: PlasmicFeaturesNavigationMenu__VariantsArgs;
  args: PlasmicFeaturesNavigationMenu__ArgsType;
  overrides: PlasmicFeaturesNavigationMenu__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          currentSection: "MyEvaluations"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "expanded",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.expanded
      },
      {
        path: "currentSection2",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.currentSection2
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootexpanded]: hasVariant($state, "expanded", "expanded") }
      )}
    >
      <div
        data-plasmic-name={"menu"}
        data-plasmic-override={overrides.menu}
        className={classNames("all", sty.menu, {
          [sty.menucurrentSection2_myCme]: hasVariant(
            $state,
            "currentSection2",
            "myCme"
          ),
          [sty.menucurrentSection2_myEvaluations]: hasVariant(
            $state,
            "currentSection2",
            "myEvaluations"
          ),
          [sty.menucurrentSection2_myGme]: hasVariant(
            $state,
            "currentSection2",
            "myGme"
          ),
          [sty.menuexpanded]: hasVariant($state, "expanded", "expanded")
        })}
        onClick={async event => {
          const $steps = {};

          $steps["updateExpanded"] = true
            ? (() => {
                const actionArgs = {
                  vgroup: "expanded",
                  operation: 2,
                  value: "expanded"
                };
                return (({ vgroup, value }) => {
                  if (typeof value === "string") {
                    value = [value];
                  }

                  const oldValue = $stateGet($state, vgroup);
                  $stateSet($state, vgroup, !oldValue);
                  return !oldValue;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateExpanded"] != null &&
            typeof $steps["updateExpanded"] === "object" &&
            typeof $steps["updateExpanded"].then === "function"
          ) {
            $steps["updateExpanded"] = await $steps["updateExpanded"];
          }
        }}
      >
        <div
          data-plasmic-name={"logo"}
          data-plasmic-override={overrides.logo}
          className={classNames("all", sty.logo, {
            [sty.logocurrentSection2_myGme]: hasVariant(
              $state,
              "currentSection2",
              "myGme"
            ),
            [sty.logoexpanded]: hasVariant($state, "expanded", "expanded")
          })}
        >
          {(
            hasVariant($state, "currentSection2", "myGme")
              ? true
              : hasVariant($state, "currentSection2", "myCme")
                ? false
                : false
          ) ? (
            <Logo
              className={classNames("__wab_instance", sty.logo__qyiw0, {
                [sty.logocurrentSection2_myCme__qyiw0Ikjgr]: hasVariant(
                  $state,
                  "currentSection2",
                  "myCme"
                ),
                [sty.logocurrentSection2_myEvaluations__qyiw0Gqm7Z]: hasVariant(
                  $state,
                  "currentSection2",
                  "myEvaluations"
                ),
                [sty.logocurrentSection2_myGme__qyiw0LBvY]: hasVariant(
                  $state,
                  "currentSection2",
                  "myGme"
                )
              })}
              interactable={true}
              product={"myGme"}
            />
          ) : null}
          {(
            hasVariant($state, "currentSection2", "myGme")
              ? false
              : hasVariant($state, "currentSection2", "myCme")
                ? false
                : true
          ) ? (
            <Logo
              className={classNames("__wab_instance", sty.logo__y3Gro, {
                [sty.logocurrentSection2_myCme__y3GroIkjgr]: hasVariant(
                  $state,
                  "currentSection2",
                  "myCme"
                ),
                [sty.logocurrentSection2_myEvaluations__y3GroGqm7Z]: hasVariant(
                  $state,
                  "currentSection2",
                  "myEvaluations"
                ),
                [sty.logocurrentSection2_myGme__y3GrolBvY]: hasVariant(
                  $state,
                  "currentSection2",
                  "myGme"
                ),
                [sty.logoexpanded__y3GroYplPn]: hasVariant(
                  $state,
                  "expanded",
                  "expanded"
                )
              })}
              grayscale={
                hasVariant($state, "expanded", "expanded")
                  ? (() => {
                      try {
                        return $props.currentSection != "MyEvaluations";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  : (() => {
                      try {
                        return $props.currentSection != "MyEvaluations";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
              }
              interactable={
                hasVariant($state, "expanded", "expanded") ? true : true
              }
              product={"myEvaluations"}
            />
          ) : null}
          {(hasVariant($state, "currentSection2", "myCme") ? true : false) ? (
            <Logo
              className={classNames("__wab_instance", sty.logo__vNiYx, {
                [sty.logocurrentSection2_myCme__vNiYxIkjgr]: hasVariant(
                  $state,
                  "currentSection2",
                  "myCme"
                ),
                [sty.logocurrentSection2_myEvaluations__vNiYxgqm7Z]: hasVariant(
                  $state,
                  "currentSection2",
                  "myEvaluations"
                ),
                [sty.logocurrentSection2_myGme__vNiYXlBvY]: hasVariant(
                  $state,
                  "currentSection2",
                  "myGme"
                )
              })}
              interactable={true}
              product={"myCme"}
            />
          ) : null}
        </div>
        <div
          data-plasmic-name={"icon"}
          data-plasmic-override={overrides.icon}
          className={classNames("all", sty.icon)}
        >
          <RoundButton
            data-plasmic-name={"roundButton"}
            data-plasmic-override={overrides.roundButton}
            ariaLabel={
              hasVariant($state, "expanded", "expanded")
                ? "Collapse product dropdown"
                : "Expand product dropdown"
            }
            className={classNames("__wab_instance", sty.roundButton, {
              [sty.roundButtoncurrentSection2_myEvaluations]: hasVariant(
                $state,
                "currentSection2",
                "myEvaluations"
              ),
              [sty.roundButtonexpanded]: hasVariant(
                $state,
                "expanded",
                "expanded"
              )
            })}
            color={"sky"}
            icon={
              <Icon64Icon
                data-plasmic-name={"arrowIcon"}
                data-plasmic-override={overrides.arrowIcon}
                className={classNames("all", sty.arrowIcon)}
                role={"img"}
              />
            }
            size={"small"}
          />
        </div>
      </div>
      <div
        data-plasmic-name={"options"}
        data-plasmic-override={overrides.options}
        className={classNames("all", sty.options, {
          [sty.optionsexpanded]: hasVariant($state, "expanded", "expanded")
        })}
      >
        {(hasVariant($state, "expanded", "expanded") ? true : false) ? (
          <div
            data-plasmic-name={"option"}
            data-plasmic-override={overrides.option}
            aria-label={"Navigate to MyEvaluations product"}
            className={classNames("all", sty.option, {
              [sty.optionexpanded]: hasVariant($state, "expanded", "expanded")
            })}
            onClick={async event => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyEvaluations"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }

              $steps["updateExpanded"] = true
                ? (() => {
                    const actionArgs = {
                      vgroup: "expanded",
                      operation: 2,
                      value: "expanded"
                    };
                    return (({ vgroup, value }) => {
                      if (typeof value === "string") {
                        value = [value];
                      }

                      const oldValue = $stateGet($state, vgroup);
                      $stateSet($state, vgroup, !oldValue);
                      return !oldValue;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateExpanded"] != null &&
                typeof $steps["updateExpanded"] === "object" &&
                typeof $steps["updateExpanded"].then === "function"
              ) {
                $steps["updateExpanded"] = await $steps["updateExpanded"];
              }
            }}
            title={"Navigate to MyEvaluations product"}
          >
            <Logo
              className={classNames("__wab_instance", sty.logo__mfIo, {
                [sty.logoexpanded__mfIoYplPn]: hasVariant(
                  $state,
                  "expanded",
                  "expanded"
                )
              })}
              grayscale={(() => {
                try {
                  return $props.currentSection != "MyEvaluations";
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return [];
                  }
                  throw e;
                }
              })()}
              interactable={true}
              product={"myEvaluations"}
            />
          </div>
        ) : null}
        {(hasVariant($state, "expanded", "expanded") ? true : false) ? (
          <div
            data-plasmic-name={"option2"}
            data-plasmic-override={overrides.option2}
            aria-label={"Navigate to MyCME product"}
            className={classNames("all", sty.option2, {
              [sty.option2currentSection2_myCme]: hasVariant(
                $state,
                "currentSection2",
                "myCme"
              ),
              [sty.option2expanded]: hasVariant($state, "expanded", "expanded")
            })}
            onClick={async event => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyCME"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }

              $steps["updateExpanded"] = true
                ? (() => {
                    const actionArgs = {
                      vgroup: "expanded",
                      operation: 2,
                      value: "expanded"
                    };
                    return (({ vgroup, value }) => {
                      if (typeof value === "string") {
                        value = [value];
                      }

                      const oldValue = $stateGet($state, vgroup);
                      $stateSet($state, vgroup, !oldValue);
                      return !oldValue;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateExpanded"] != null &&
                typeof $steps["updateExpanded"] === "object" &&
                typeof $steps["updateExpanded"].then === "function"
              ) {
                $steps["updateExpanded"] = await $steps["updateExpanded"];
              }
            }}
            title={"Navigate to MyCME product"}
          >
            {(
              hasVariant($state, "expanded", "expanded")
                ? true
                : hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : false
            ) ? (
              <Logo
                className={classNames("__wab_instance", sty.logo__oJ0Tf, {
                  [sty.logoexpanded__oJ0TfYplPn]: hasVariant(
                    $state,
                    "expanded",
                    "expanded"
                  )
                })}
                grayscale={(() => {
                  try {
                    return $props.currentSection != "MyCME";
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()}
                interactable={true}
                product={"myCme"}
              />
            ) : null}
          </div>
        ) : null}
        {(hasVariant($state, "expanded", "expanded") ? true : false) ? (
          <div
            data-plasmic-name={"option3"}
            data-plasmic-override={overrides.option3}
            aria-label={"Navigate to MyGME FISCAL product"}
            className={classNames("all", sty.option3, {
              [sty.option3expanded]: hasVariant($state, "expanded", "expanded")
            })}
            onClick={async event => {
              const $steps = {};

              $steps["runOnProductClick"] = true
                ? (() => {
                    const actionArgs = {
                      eventRef: $props["onProductClick"],
                      args: ["MyGME"]
                    };
                    return (({ eventRef, args }) => {
                      return eventRef?.(...(args ?? []));
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["runOnProductClick"] != null &&
                typeof $steps["runOnProductClick"] === "object" &&
                typeof $steps["runOnProductClick"].then === "function"
              ) {
                $steps["runOnProductClick"] = await $steps["runOnProductClick"];
              }

              $steps["updateExpanded"] = true
                ? (() => {
                    const actionArgs = {
                      vgroup: "expanded",
                      operation: 2,
                      value: "expanded"
                    };
                    return (({ vgroup, value }) => {
                      if (typeof value === "string") {
                        value = [value];
                      }

                      const oldValue = $stateGet($state, vgroup);
                      $stateSet($state, vgroup, !oldValue);
                      return !oldValue;
                    })?.apply(null, [actionArgs]);
                  })()
                : undefined;
              if (
                $steps["updateExpanded"] != null &&
                typeof $steps["updateExpanded"] === "object" &&
                typeof $steps["updateExpanded"].then === "function"
              ) {
                $steps["updateExpanded"] = await $steps["updateExpanded"];
              }
            }}
            title={"Navigate to MyGME FISCAL product"}
          >
            {(
              hasVariant($state, "expanded", "expanded")
                ? true
                : hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : false
            ) ? (
              <Logo
                className={classNames("__wab_instance", sty.logo__pKa, {
                  [sty.logoexpanded__pKaYplPn]: hasVariant(
                    $state,
                    "expanded",
                    "expanded"
                  )
                })}
                grayscale={(() => {
                  try {
                    return $props.currentSection != "MyGME";
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return [];
                    }
                    throw e;
                  }
                })()}
                interactable={true}
                product={"myGme"}
              />
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "menu",
    "logo",
    "icon",
    "roundButton",
    "arrowIcon",
    "options",
    "option",
    "option2",
    "option3"
  ],
  menu: ["menu", "logo", "icon", "roundButton", "arrowIcon"],
  logo: ["logo"],
  icon: ["icon", "roundButton", "arrowIcon"],
  roundButton: ["roundButton", "arrowIcon"],
  arrowIcon: ["arrowIcon"],
  options: ["options", "option", "option2", "option3"],
  option: ["option"],
  option2: ["option2"],
  option3: ["option3"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  menu: "div";
  logo: "div";
  icon: "div";
  roundButton: typeof RoundButton;
  arrowIcon: "svg";
  options: "div";
  option: "div";
  option2: "div";
  option3: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFeaturesNavigationMenu__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFeaturesNavigationMenu__VariantsArgs;
    args?: PlasmicFeaturesNavigationMenu__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFeaturesNavigationMenu__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFeaturesNavigationMenu__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFeaturesNavigationMenu__ArgProps,
          internalVariantPropNames: PlasmicFeaturesNavigationMenu__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFeaturesNavigationMenu__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFeaturesNavigationMenu";
  } else {
    func.displayName = `PlasmicFeaturesNavigationMenu.${nodeName}`;
  }
  return func;
}

export const PlasmicFeaturesNavigationMenu = Object.assign(
  // Top-level PlasmicFeaturesNavigationMenu renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    menu: makeNodeComponent("menu"),
    logo: makeNodeComponent("logo"),
    icon: makeNodeComponent("icon"),
    roundButton: makeNodeComponent("roundButton"),
    arrowIcon: makeNodeComponent("arrowIcon"),
    options: makeNodeComponent("options"),
    option: makeNodeComponent("option"),
    option2: makeNodeComponent("option2"),
    option3: makeNodeComponent("option3"),

    // Metadata about props expected for PlasmicFeaturesNavigationMenu
    internalVariantProps: PlasmicFeaturesNavigationMenu__VariantProps,
    internalArgProps: PlasmicFeaturesNavigationMenu__ArgProps
  }
);

export default PlasmicFeaturesNavigationMenu;
/* prettier-ignore-end */
